import * as d3 from 'd3'

import { getColorByGradYear } from './util'

const buildDataModel = (gradYearCounts, total) => {
  const toPercent = d3.scaleLinear().domain([0, total]).range([0, 100])

  let leftEdgeX = 0
  return gradYearCounts
    .map((gradYear) => {
      const value = gradYear.counts.college_reached_count || 0
      const data = {
        gradYear: gradYear.grad_year,
        percent: toPercent(value),
        value,
        leftEdgeX,
      }
      leftEdgeX += data.value
      return data
    })
    .filter((d) => d.value > 0)
}

const roundedRectangle = (x, y, w, h, r, tl, tr, bl, br) => {
  let path
  path = 'M' + (x + r) + ',' + y
  path += 'h' + (w - 2 * r)
  if (tr) {
    path += 'a' + r + ',' + r + ' 0 0 1 ' + r + ',' + r
  } else {
    path += 'h' + r
    path += 'v' + r
  }
  path += 'v' + (h - 2 * r)
  if (br) {
    path += 'a' + r + ',' + r + ' 0 0 1 ' + -r + ',' + r
  } else {
    path += 'v' + r
    path += 'h' + -r
  }
  path += 'h' + (2 * r - w)
  if (bl) {
    path += 'a' + r + ',' + r + ' 0 0 1 ' + -r + ',' + -r
  } else {
    path += 'h' + -r
    path += 'v' + -r
  }
  path += 'v' + (2 * r - h)
  if (tl) {
    path += 'a' + r + ',' + r + ' 0 0 1 ' + r + ',' + -r
  } else {
    path += 'v' + -r
    path += 'h' + r
  }
  path += 'z'
  return path
}

export const renderChart = (container, seniorGradYear, total, gradYearCounts, onMouseOver, onMouseLeave) => {
  const chartContainer = d3.select(container).node()
  const chartWidth = chartContainer.getBoundingClientRect().width
  const barBorderRadis = 8
  const barPadding = 7
  const barHeight = 26

  const data = buildDataModel(gradYearCounts, total)

  const getRoundedRectangle = (x, width) => {
    return roundedRectangle(x, 0, width, barHeight, barBorderRadis, true, true, true, true)
  }
  const getLeftRoundedRectangle = (x, width) => {
    return roundedRectangle(x, 0, width, barHeight, barBorderRadis, true, false, true)
  }
  const getRightRoundedRectangle = (x, width) => {
    return roundedRectangle(x, 0, width, barHeight, barBorderRadis, false, true, false, true)
  }
  const getRectangle = (x, width) => {
    return roundedRectangle(x, 0, width, barHeight, 0)
  }
  const isFirst = (i) => i === 0
  const isLast = (i) => i === data.length - 1

  const xScale = d3.scaleLinear().domain([0, total]).range([0, chartWidth])

  let svg = d3.select(container).select('svg').select('g')

  if (svg.empty()) {
    svg = d3.select(container).append('svg').attr('width', '100%').attr('height', barHeight).append('g')
  }

  const bars = svg.selectAll('path').data(data)
  bars.enter().append('path')
  bars.exit().remove()
  bars
    .on('mouseover', ({ gradYear, value }, index, elements) => onMouseOver(gradYear, value, elements[index]))
    .on('mouseleave', onMouseLeave)
    .attr('d', (d, i) => {
      if (isFirst(i) && isLast(i)) {
        return getRoundedRectangle(xScale(d.leftEdgeX), 0)
      } else if (isFirst(i)) {
        return getLeftRoundedRectangle(xScale(d.leftEdgeX), 0)
      } else if (isLast(i)) {
        return getRightRoundedRectangle(xScale(d.leftEdgeX), 0)
      }
      return getRectangle(xScale(d.leftEdgeX), 0)
    })
    .style('fill', (d) => getColorByGradYear(seniorGradYear, d.gradYear))
    .transition()
    .duration(1000)
    .attr('d', (d, i) => {
      if (isFirst(i) && isLast(i)) {
        return getRoundedRectangle(xScale(d.leftEdgeX), xScale(d.value))
      } else if (isFirst(i)) {
        return getLeftRoundedRectangle(xScale(d.leftEdgeX), xScale(d.value) - barPadding)
      } else if (isLast(i)) {
        return getRightRoundedRectangle(xScale(d.leftEdgeX), xScale(d.value))
      }
      return getRectangle(xScale(d.leftEdgeX), xScale(d.value) - barPadding)
    })
}
